// removed by extract-text-webpack-plugin
module.exports = {"next":"_3Fbn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/next/index.less
// module id = 256
// module chunks = 0